import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import config from 'constants/config'
import productLabels from 'i18n/productLabels'

function usePurchaseSynonymLabels() {
  const intl = useIntl()
  const purchaseSynonym = config.brandConfig.purchaseSynonym

  return useMemo(() => {
    const purchaseSynonymLabel = (() => {
      if (purchaseSynonym === 'escape') {
        return intl.formatMessage({
          id: '_-LctDusvWHodg4uAX_m',
          defaultMessage: 'escape',
        })
      }

      if (purchaseSynonym === 'booking') {
        return intl.formatMessage({
          id: '8al1kKfjH2cn62pVff34',
          defaultMessage: 'booking',
        })
      }

      return intl.formatMessage({
        id: 'gzIWi6mGb4bVGj68G4kJ',
        defaultMessage: 'purchase',
      })
    })()

    const myPurchases = (() => {
      if (purchaseSynonym === 'escape') {
        return intl.formatMessage(productLabels.myEscapes)
      }

      if (purchaseSynonym === 'booking') {
        return intl.formatMessage({
          id: 'uN-vVoJGfR6Xi1K4E_q6',
          defaultMessage: 'My Bookings',
        })
      }

      return intl.formatMessage({
        id: '-QOPCZu2uRwE-x1yuuqc',
        defaultMessage: 'My Purchases',
      })
    })()

    return { myPurchases, purchaseSynonym: purchaseSynonymLabel }
  }, [intl, purchaseSynonym])
}

export default usePurchaseSynonymLabels
